import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type MicrosoftEmailOAuthCallbackInput = {
  authCode: string;
  state: string;
};

export const useMicrosoftEmailOAuthCallbackMutation = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<{ data: unknown }, Error, MicrosoftEmailOAuthCallbackInput>({
    mutationFn: (input: MicrosoftEmailOAuthCallbackInput) =>
      api.post('oauth/callback', {
        ...input,
        platform: 'MICROSOFT',
        functionality: 'EMAIL_SEND',
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['oauth', 'connection-status'] });
    },
  });

  const completeMicrosoftEmailOAuth = async (
    input: MicrosoftEmailOAuthCallbackInput,
  ): Promise<void> => {
    await mutateAsync(input);
  };

  return {
    completeMicrosoftEmailOAuth,
    isLoading,
    error,
  };
};
